import { useLocation } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { getFirstStepVideo } from 'modules/onboarding/lib/firstSteps/videos'

import FirstStepsModal from './Modal'

const FirstSteps = () => {
  const {
    access: { locale },
  } = useCurrentSession()

  const location = useLocation()

  const video = getFirstStepVideo('location', location.pathname, locale)

  if (!video) return null

  return <FirstStepsModal video={video} />
}

export default FirstSteps
